<script setup lang="ts">
    interface AlgoliaFacetDetailsProps {
        open?: boolean;
        facetName: string;
    }

    defineProps<AlgoliaFacetDetailsProps>();
</script>
<template>
    <details
        :open="open"
        class="atm-algolia-facet-details open:border-b open:border-woom-grey-taupe lg:hidden">
        <summary class="h-12 items-center justify-between border-b border-woom-grey-mid px-6 capitalize">
            {{ facetName }}
            <woom-icon-chevron-down class="size-6 shrink-0" />
        </summary>
        <slot></slot>
    </details>
</template>
<style scoped>
    @reference "#main.css";

    details[open] > summary {
        @apply font-bold;
    }

    details::details-content {
        @apply px-6 py-1;
    }
</style>
